import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../api';
import { usePageState } from '../hooks/usePageState';
import HypothesisTooltip, { useHypothesisData } from '../components/HypothesisTooltip';

const CAT_GIFS_MON = ["https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif","https://media.giphy.com/media/vFKqnCdLPNOKc/giphy.gif","https://media.giphy.com/media/mlvseq9yvZhba/giphy.gif","https://media.giphy.com/media/pFwRzOLfuGHok/giphy.gif","https://media.giphy.com/media/10dU7AN7xsi1I4/giphy.gif","https://media.giphy.com/media/nR4L10XlJcSeQ/giphy.gif","https://media.giphy.com/media/3oriO0OEd9QIDdllqo/giphy.gif","https://media.giphy.com/media/ule4vhcY1xEKQ/giphy.gif","https://media.giphy.com/media/GeimqsH0TLDt4tScGw/giphy.gif","https://media.giphy.com/media/BzyTuYCmvSORqs1ABM/giphy.gif","https://media.giphy.com/media/pY8jLmZw0ElqvVeRH4/giphy.gif","https://media.giphy.com/media/yWku98eNsMSZOEEWnC/giphy.gif","https://media.giphy.com/media/lh6EKzQdQghw784jvq/giphy.gif","https://media.giphy.com/media/BK1EfIsdkKZMY/giphy.gif","https://media.giphy.com/media/weIRemP4BI4U98HeGX/giphy.gif","https://media.giphy.com/media/12HZukMBlutpoQ/giphy.gif","https://media.giphy.com/media/EFnV02XHwNeIX65Gc7/giphy.gif","https://media.giphy.com/media/9n0CvokbUMaWhFuCkp/giphy.gif","https://media.giphy.com/media/X3ewes5lWn41o6hUjy/giphy.gif","https://media.giphy.com/media/TKa7fQzChHylCQ89to/giphy.gif","https://media.giphy.com/media/v6HmjWFF80ByC2JcRl/giphy.gif","https://media.giphy.com/media/In0Lpu4FVivjISX9HT/giphy.gif","https://media.giphy.com/media/2g6sCTsSoVuSfSxK4W/giphy.gif","https://media.giphy.com/media/cbm0J4DEIqKHsKxYHA/giphy.gif"];
function getSmartCatGif() {
  const key = 'cat_gif_weights';
  let weights = JSON.parse(localStorage.getItem(key) || 'null');
  if (!weights || weights.length !== CAT_GIFS_MON.length) weights = CAT_GIFS_MON.map(() => 10);
  // Выбираем по весам
  const total = weights.reduce((s,w) => s+w, 0);
  let rand = Math.random() * total;
  let chosen = 0;
  for (let i = 0; i < weights.length; i++) {
    rand -= weights[i];
    if (rand <= 0) { chosen = i; break; }
  }
  // Уменьшаем вес выбранного, увеличиваем остальные
  weights = weights.map((w, i) => i === chosen ? Math.max(1, w - 4) : Math.min(10, w + 1));
  localStorage.setItem(key, JSON.stringify(weights));
  return CAT_GIFS_MON[chosen];
}

function pad(n) { return String(n).padStart(2,'0'); }
function fmtDate(d) { const dt=new Date(d); return `${pad(dt.getDate())}.${pad(dt.getMonth()+1)}`; }
function toISO(d) { return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`; }
function addDays(d,n) { const dt=new Date(d); dt.setDate(dt.getDate()+n); return dt; }
function todayMSK() {
  const now = new Date();
  const msk = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
  return msk;
}
function ordersColor(qty) {
  if (qty===0) return '#ef4444';
  if (qty>=30) return '#10b981';
  if (qty<=10) { const t=qty/10; return `rgb(${Math.round(239+(245-239)*t)},${Math.round(68+(158-68)*t)},${Math.round(68+(11-68)*t)})`; }
  const t=(qty-10)/20;
  return `rgb(${Math.round(245+(16-245)*t)},${Math.round(158+(185-158)*t)},${Math.round(11+(129-11)*t)})`;
}
function fmt(v,dec=0) {
  if(v===null||v===undefined||v==='') return '—';
  const n=Number(v); if(isNaN(n)) return '—';
  return n.toLocaleString('ru-RU',{maximumFractionDigits:dec});
}
function fmtPct(v) { if(v===null||v===undefined||v==='') return '—'; return `${fmt(v,1)}%`; }
function snakeToCamel(s){return s.replace(/_([a-z])/g,(_,c)=>c.toUpperCase());}

const currentYear = new Date().getFullYear();
const YEARS = [currentYear-2, currentYear-1, currentYear];
const CELL_W = 72;
const ROW_LABELS = ['Заказы, шт','Наша цена','%СПП+кошелёк','Цена с СПП','Сумма заказов','Затраты рекл.','ДРР заказов','Прогноз ДРР','Прогноз маржи','','+ размеры'];
const DEFAULT_WIDTHS = {
  photo:44, article:90, stockWbActive:52, stockFbs:52, toClient:48, fromClient:48,
  ffStockAfterOrders:52, china:44, buyoutWeeks:128,
  breakeven:52, m10:46, m22:46, m27:46, comment:120, ordersPlan:48, labels:130,
};
const iSt={background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text)',borderRadius:6,padding:'4px 8px',fontSize:12};

// ─── Дата-селектор ───────────────────────────────────────────────
function DateSelector({ from, to, onChange, lastSync, onSync, syncing, syncBlockSecs=0, syncLimits={used:0,limit:10}, initialMode='30days', initialFrom, initialTo, blurIds=false, onToggleBlur=()=>{}, onSyncFbs=()=>{}, syncingFbs=false, fbsSyncStatus='' }) {
  const [year, setYear] = useState(currentYear);
  const [mode, setMode] = useState(initialMode);
  const [cFrom, setCFrom] = useState(initialFrom || from);
  const [cTo, setCTo] = useState(initialTo || to);
  const [showYears, setShowYears] = useState(false);
  const [showPeriod, setShowPeriod] = useState(false);
  const prevMode = useRef(null);

  useEffect(() => {
    if (prevMode.current === null) { prevMode.current = mode; return; }
    if (prevMode.current === mode) return;
    prevMode.current = mode;
    if (mode==='custom') return;
    const today = todayMSK();
    let f, t = toISO(today);
    if (year !== currentYear) { onChange(`${year}-01-01`,`${year}-12-31`,mode); return; }
    if (mode==='7days')  f = toISO(addDays(today,-6));
    if (mode==='14days') f = toISO(addDays(today,-13));
    if (mode==='30days') f = toISO(addDays(today,-29));
    if (mode==='year')   { f=`${currentYear}-01-01`; t=toISO(today); }
    if (mode==='decade') {
      const d=today.getDate();
      let decStart, decEnd;
      if (d<=10) { decStart=1; decEnd=10; }
      else if (d<=20) { decStart=11; decEnd=20; }
      else { decStart=21; decEnd=new Date(today.getFullYear(),today.getMonth()+1,0).getDate(); }
      f = toISO(new Date(today.getFullYear(),today.getMonth(),decStart));
      t = toISO(new Date(today.getFullYear(),today.getMonth(),decEnd));
    }
    if (f) onChange(f,t,mode);
  }, [mode, year]);

  const modeLabels = {'7days':'7 дней','14days':'14 дней','30days':'30 дней','decade':'Декада','year':'Год','custom':'Произвольно'};
  const syncAgo = lastSync ? Math.round((Date.now()-new Date(lastSync))/3600000) : null;
  const btnStyle = (active) => ({
    padding:'5px 12px', fontSize:12, fontWeight:600, borderRadius:8, cursor:'pointer',
    border: active ? '1px solid rgba(59,130,246,0.5)' : '1px solid rgba(255,255,255,0.08)',
    background: active ? 'rgba(59,130,246,0.18)' : 'rgba(255,255,255,0.04)',
    color: active ? '#60a5fa' : 'rgba(200,215,235,0.7)',
    transition:'all 0.15s',
    boxShadow: active ? '0 0 12px rgba(59,130,246,0.15)' : 'none',
  });

  return (
    <div style={{display:'flex',alignItems:'center',gap:8,flex:1,flexWrap:'wrap'}}>

      {/* Год — дропдаун */}
      <div style={{position:'relative'}}>
        <button onClick={()=>{setShowYears(s=>!s);setShowPeriod(false);}} style={btnStyle(year!==currentYear||showYears)}>
          {year} ▾
        </button>
        {showYears && (
          <div style={{position:'absolute',top:'110%',left:0,zIndex:100,background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:6,display:'flex',flexDirection:'column',gap:4,minWidth:90,boxShadow:'0 8px 24px rgba(0,0,0,0.4)'}}>
            {YEARS.map(y=>(
              <button key={y} onClick={()=>{
                setYear(y); setShowYears(false);
                if (y !== currentYear) { setMode('custom'); const f=`${y}-01-01`,t=`${y}-12-31`; setCFrom(f);setCTo(t);onChange(f,t,'custom'); }
                else { setMode('30days'); }
              }} style={{...btnStyle(year===y), padding:'4px 12px', fontSize:12}}>{y}</button>
            ))}
          </div>
        )}
      </div>

      {/* Период — дропдаун */}
      <div style={{position:'relative'}}>
        <button onClick={()=>{setShowPeriod(s=>!s);setShowYears(false);}} style={btnStyle(true)}>
          {modeLabels[mode]||mode} ▾
        </button>
        {showPeriod && (
          <div style={{position:'absolute',top:'110%',left:0,zIndex:100,background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:6,display:'flex',flexDirection:'column',gap:4,minWidth:130,boxShadow:'0 8px 24px rgba(0,0,0,0.4)'}}>
            {(year===currentYear
              ? [{k:'7days',l:'7 дней'},{k:'14days',l:'14 дней'},{k:'30days',l:'30 дней'},{k:'year',l:'Год'},{k:'decade',l:'Декада'},{k:'custom',l:'Произвольно'}]
              : [{k:'custom',l:'Весь год'}]
            ).map(b=>(
              <button key={b.k} onClick={()=>{setMode(b.k);setShowPeriod(false);}} style={{...btnStyle(mode===b.k), padding:'4px 12px', fontSize:12, textAlign:'left'}}>{b.l}</button>
            ))}
          </div>
        )}
      </div>

      {/* Произвольный диапазон */}
      {mode==='custom'&&(<>
        <input type="date" value={cFrom} onChange={e=>setCFrom(e.target.value)} style={iSt}/>
        <span style={{color:'var(--text-muted)',fontSize:12}}>—</span>
        <input type="date" value={cTo} onChange={e=>setCTo(e.target.value)} style={iSt}/>
        <button onClick={()=>onChange(cFrom,cTo,'custom')} style={{padding:'5px 14px',fontSize:12,fontWeight:600,borderRadius:8,background:'linear-gradient(135deg,#2563eb,#3b82f6)',color:'#fff',border:'none',cursor:'pointer'}}>Применить</button>
      </>)}

      {/* Синхронизация и сброс кэша */}
      <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
        {syncAgo!==null&&<span style={{fontSize:11,color:'var(--text-muted)'}}>Данные WB: {syncAgo===0?'только что':`${syncAgo} ч. назад`}</span>}
        <button onClick={onSync} disabled={syncing||syncLimits.used>=syncLimits.limit||syncBlockSecs>0} style={{
          padding:'5px 12px',fontSize:12,fontWeight:600,borderRadius:6,
          background:syncing||syncLimits.used>=syncLimits.limit||syncBlockSecs>0?'var(--surface)':'rgba(59,130,246,0.15)',
          color:syncing||syncLimits.used>=syncLimits.limit||syncBlockSecs>0?'var(--text-muted)':'var(--accent)',
          border:'1px solid rgba(59,130,246,0.3)',cursor:syncing||syncLimits.used>=syncLimits.limit||syncBlockSecs>0?'not-allowed':'pointer',
        }}>{syncing?'⟳ Синхр...':syncBlockSecs>0?`↻ ${Math.floor(syncBlockSecs/60)}:${String(syncBlockSecs%60).padStart(2,'0')}`:'↻ Синхр. WB'}</button>
        <span style={{fontSize:10,color:syncLimits.used>=syncLimits.limit?'var(--red)':'var(--text-muted)'}}>{syncLimits.used}/{syncLimits.limit}</span>
        <button onClick={()=>window.location.reload(true)} style={{padding:'5px 12px',fontSize:12,fontWeight:600,borderRadius:6,background:'rgba(255,255,255,0.05)',color:'rgba(200,215,235,0.5)',border:'1px solid rgba(255,255,255,0.1)',cursor:'pointer'}}>↺ Кэш</button>
        <button onClick={onToggleBlur} style={{padding:'5px 12px',fontSize:12,fontWeight:600,borderRadius:6,background:blurIds?'rgba(239,68,68,0.15)':'rgba(255,255,255,0.05)',color:blurIds?'#ef4444':'rgba(200,215,235,0.5)',border:blurIds?'1px solid rgba(239,68,68,0.3)':'1px solid rgba(255,255,255,0.1)',cursor:'pointer'}}>{blurIds?'👁 Показать ID':'🙈 Скрыть ID'}</button>
        <button onClick={onSyncFbs} disabled={syncingFbs} style={{padding:'5px 12px',fontSize:12,fontWeight:600,borderRadius:6,
          background: syncingFbs?'rgba(59,130,246,0.15)':fbsSyncStatus==='done'?'rgba(16,185,129,0.2)':fbsSyncStatus==='error'?'rgba(239,68,68,0.15)':'rgba(16,185,129,0.08)',
          color: syncingFbs?'#60a5fa':fbsSyncStatus==='done'?'#10b981':fbsSyncStatus==='error'?'#ef4444':'#10b981',
          border: syncingFbs?'1px solid rgba(59,130,246,0.4)':fbsSyncStatus==='done'?'1px solid rgba(16,185,129,0.5)':fbsSyncStatus==='error'?'1px solid rgba(239,68,68,0.4)':'1px solid rgba(16,185,129,0.25)',
          cursor:syncingFbs?'not-allowed':'pointer', transition:'all 0.3s'}}>
          {syncingFbs?'⟳ Обновляем FBS...':fbsSyncStatus==='done'?'✓ FBS обновлён':fbsSyncStatus==='error'?'✗ Ошибка FBS':'↻ Обновить FBS'}
        </button>
      </div>
    </div>
  );
}

// ─── Редактируемая ячейка ────────────────────────────────────────
function EditCell({nmId,field,value,suffix='',onSaved,tooltip=''}) {
  const [editing,setEditing]=useState(false);
  const [val,setVal]=useState(value??'');
  const ref=useRef();
  useEffect(()=>{if(editing)ref.current?.focus();},[editing]);
  const save=async()=>{
    setEditing(false);
    if(String(val)===String(value??'')) return;
    try { await api.post('/monitoring/manual',{nmId,field,value:val}); onSaved(nmId,field,val); }
    catch(e){console.error(e);}
  };
  if(editing) return(
    <input ref={ref} value={val} onChange={e=>setVal(e.target.value)}
      onBlur={save} onKeyDown={e=>{if(e.key==='Enter')save();if(e.key==='Escape')setEditing(false);}}
      style={{width:'100%',background:'var(--bg)',border:'1px solid var(--accent)',color:'var(--text)',borderRadius:4,padding:'1px 4px',fontSize:11,textAlign:'center'}}/>
  );
  return(
    <div onClick={()=>setEditing(true)} title={tooltip || "Нажмите для редактирования"}
      style={{cursor:'text',fontSize:12,fontWeight:600,color:'var(--text)',textAlign:'center',padding:'1px 2px',borderRadius:3,border:'1px solid transparent',transition:'border-color 0.15s'}}
      onMouseEnter={e=>e.currentTarget.style.borderColor='var(--border)'}
      onMouseLeave={e=>e.currentTarget.style.borderColor='transparent'}>
      {value!=null&&value!==''?`${fmt(value)}${suffix}`:<span style={{color:'var(--border)',fontSize:10}}>—</span>}
    </div>
  );
}

function useColWidths(defaults) {
  const [widths, setWidths] = useState(defaults);
  const startResize = (key, e) => {
    e.preventDefault();
    const startX = e.clientX, startW = widths[key];
    const onMove = (ev) => setWidths(w => ({...w, [key]: Math.max(40, startW + ev.clientX - startX)}));
    const onUp = () => { document.removeEventListener('mousemove',onMove); document.removeEventListener('mouseup',onUp); };
    document.addEventListener('mousemove',onMove);
    document.addEventListener('mouseup',onUp);
  };
  return [widths, startResize];
}

// ─── Строка артикула ─────────────────────────────────────────────
function ArticleRow({article, dates=[], onSaved, isOdd, widths, buyoutWeeks=[], fixedW, isFavorite=false, onToggleFavorite, onHide=()=>{}, onTag=()=>{}, tag='', adMarks={}, toggleAdMark=()=>{}, searchMatch=false, hypoData={}, onCommentChange=()=>{}}) {
  const [expanded, setExpanded] = useState(false);
  const scrolledRef = useRef(false);
  useEffect(() => { if (!searchMatch) scrolledRef.current = false; }, [searchMatch]);
  const rowRef = searchMatch ? (el => { if (el && !scrolledRef.current) { scrolledRef.current = true; el.scrollIntoView({behavior:'smooth', block:'center'}); } }) : null;
  const bg = isOdd ? 'rgba(255,255,255,0.018)' : 'transparent';
  const fixedBg = isOdd ? '#142636' : 'var(--surface)';

  const normalizeSize = s => s.replace(/\s+/g, '');
  const getSizeVal = (obj, size) => {
    if (!obj) return 0;
    if (obj[size] != null) return obj[size];
    const norm = normalizeSize(size);
    const key = Object.keys(obj).find(k => normalizeSize(k) === norm);
    return key ? (obj[key] || 0) : 0;
  };
  const sizeMap = {};
  const isValidSize = s => s.length <= 6 && !/^\d{10,}$/.test(s);
  [...Object.keys(article.stockWbSizes||{}),
   ...Object.keys(article.toClientSizes||{}),
   ...Object.keys(article.fromClientSizes||{}),
   ...Object.keys(article.ffStockSizes||{})
  ].filter(isValidSize).forEach(s => { const n = normalizeSize(s); if (!sizeMap[n]) sizeMap[n] = s; });
  const sizes = Object.values(sizeMap).sort((a,b)=>isNaN(normalizeSize(a))?a.localeCompare(b):Number(normalizeSize(a))-Number(normalizeSize(b)));

  function calcFdrr(d) {
    const s=d?.spend_all||0, os=d?.orders_sum||0;
    const vals=[article.buyoutW1,article.buyoutW2,article.buyoutW3,article.buyoutW4].filter(v=>v!=null&&v>0);
    const bp = vals.length>0 ? Math.round(vals.reduce((a,b)=>a+b,0)/vals.length*100)/100 : (article.buyoutPlan||0);
    if(!s||!os||!bp) return null;
    return s/(os*bp/100)*100;
  }

  return (
    <div style={{borderBottom:'1px solid var(--border)', background:bg}}>
      <div ref={rowRef} style={{display:'flex', minHeight:36}}>
        <div style={{display:'flex', width:fixedW, flexShrink:0, position:'sticky', left:0, zIndex:2, background:fixedBg, borderRight:'2px solid var(--border)'}}>
          <div style={{width:widths.photo,display:'flex',alignItems:'center',justifyContent:'center',padding:'4px 2px',borderRight:'1px solid var(--border)'}}>
            {article.photo ? <img src={article.photo} alt="" className="wb-photo" style={{width:36,height:36,objectFit:'cover',borderRadius:5}}/> : <div style={{width:36,height:36,background:'var(--border)',borderRadius:5}}/>}
          </div>
          <div style={{width:widths.article,padding:'4px 4px',display:'flex',flexDirection:'column',justifyContent:'center',borderRight:'1px solid var(--border)',position:'relative'}}>
            <div style={{fontSize:10,fontWeight:700,color:'var(--text)',wordBreak:'break-all'}}><span className="blur-nmid">{article.nmId}</span></div>
            <div style={{fontSize:9,color:'var(--text-muted)',marginTop:1,wordBreak:'break-all'}}>{article.vendorCode}</div>
            <button onClick={()=>onToggleFavorite(article.nmId)} style={{position:'absolute',top:2,right:2,background:'transparent',border:'none',cursor:'pointer',fontSize:12,lineHeight:1,padding:1,color:isFavorite?'#ef4444':'var(--border)'}}>
              {isFavorite?'❤️':'🤍'}
            </button>
            <button onClick={()=>onHide(article.nmId)} title="Скрыть артикул" style={{position:'absolute',bottom:2,right:2,background:'transparent',border:'none',cursor:'pointer',fontSize:11,lineHeight:1,padding:1,color:'#ef4444',opacity:0.7,fontWeight:700}}
              onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.7}>
              ✕
            </button>
            <button onClick={()=>onTag(article.nmId)} title={tag===''?'Отметить топ/слив':tag==='top'?'Топ → Слив':'Убрать метку'} style={{position:'absolute',top:2,left:2,background:'transparent',border:'none',cursor:'pointer',fontSize:11,lineHeight:1,padding:1}}>
              <span style={{
                fontSize:9, borderRadius:3, padding:'1px 4px',
                background: tag==='top'?'rgba(16,185,129,0.15)':tag==='flop'?'rgba(239,68,68,0.15)':'rgba(255,255,255,0.07)',
                border: tag==='top'?'1px solid rgba(16,185,129,0.4)':tag==='flop'?'1px solid rgba(239,68,68,0.4)':'1px solid rgba(255,255,255,0.15)',
                color: tag==='top'?'#10b981':tag==='flop'?'#ef4444':'rgba(200,215,235,0.4)',
              }}>{tag==='top'?'▲Топ':tag==='flop'?'▼Слив':'○'}</span>
            </button>
          </div>
          {[{w:widths.stockWbActive,v:article.stockWbActive,k:'stockWbActive',accent:true},{w:widths.stockFbs,v:article.stockFbs,k:'stockFbs',accent:true},{w:widths.toClient,v:article.toClient,k:'toClient',accent:false},{w:widths.fromClient,v:article.fromClient,k:'fromClient',accent:false}].map(col=>(
            <div key={col.k} style={{width:col.w,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',fontSize:11,fontWeight:600,color:col.accent?'#10b981':'var(--text)',background:col.accent?'rgba(16,185,129,0.07)':'transparent'}}>{col.v||0}</div>
          ))}
          <div style={{width:widths.ffStockAfterOrders,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',fontSize:11,fontWeight:600,color:article.ffStockAfterOrders!=null?'#10b981':'var(--text-muted)'}}>{article.ffStockAfterOrders??'—'}</div>
          <div style={{width:widths.china,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)'}}>
            <EditCell nmId={article.nmId} field="china_transit" value={article.chinaTransit} onSaved={onSaved}/>
          </div>

          <div style={{width:widths.buyoutWeeks,display:'flex',alignItems:'center',justifyContent:'center',gap:3,borderRight:'1px solid var(--border)'}}>
            {[['W1',article.buyoutW1],['W2',article.buyoutW2],['W3',article.buyoutW3],['W4',article.buyoutW4]].map(([label,w],i)=>{
              const wk=buyoutWeeks[i];
              // Считаем даты W1-W4 — неделя пн-вс, крон во вторник
              const now=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Moscow'}));
              const day=now.getDay();
              // Находим последний понедельник (начало W1)
              const daysToLastMon=day>=1?day-1:6;
              const lastMon=new Date(now);lastMon.setDate(now.getDate()-daysToLastMon);
              // W1 = прошлая неделя (пн-вс)
              const sun=new Date(lastMon);sun.setDate(lastMon.getDate()-1-i*7);
              const mon=new Date(sun);mon.setDate(sun.getDate()-6);
              const fmt=d=>d.toLocaleDateString('ru-RU',{day:'2-digit',month:'2-digit'});
              const dateRange=`${fmt(mon)}–${fmt(sun)}`;
              return(
                <div key={i} title={`${label}: ${dateRange}`} style={{display:'flex',flexDirection:'column',alignItems:'center',cursor:'default'}}>
                  <span style={{fontSize:8,color:'var(--text-muted)',lineHeight:'10px'}}>{label}</span>
                  <span style={{fontSize:10,fontWeight:700,lineHeight:'14px',color:w===null?'var(--text-muted)':w>=50?'var(--green)':w>=30?'var(--yellow)':'var(--red)'}}>
                    {w===null?'—':`${w}%`}
                  </span>
                </div>
              );
            })}
          </div>
          <div title={[
              '📦 Себес+ФФ: ' + (article.breakevenSeb != null ? Math.round(article.breakevenSeb) + ' ₽' : '—'),
              '🚚 Логистика: ' + (article.breakevenLog != null ? Math.round(article.breakevenLog) + ' ₽' : '—'),
              '🏪 Хранение: ' + (article.breakevenHran != null ? Math.round(article.breakevenHran) + ' ₽' : '—'),
              '💳 Комиссия WB: ' + (article.breakevenComm != null ? Math.round(article.breakevenComm) + ' ₽' : '—'),
              '🧾 Налог: ' + (article.breakevenTax != null ? Math.round(article.breakevenTax) + ' ₽' : '—'),
              '─────────────',
              '✅ Итого: ' + (article.breakevenPrice != null ? article.breakevenPrice + ' ₽' : '—'),
              '🔄 Обновляется каждый понедельник в 11:00 МСК',
            ].join('\n')} style={{width:widths.breakeven,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',cursor:'help'}}>
            <div title={[
              '📦 Себес+ФФ: ' + (article.breakevenSeb != null ? Math.round(article.breakevenSeb) + ' ₽' : '—'),
              '🚚 Логистика: ' + (article.breakevenLog != null ? Math.round(article.breakevenLog) + ' ₽' : '—'),
              '🏪 Хранение: ' + (article.breakevenHran != null ? Math.round(article.breakevenHran) + ' ₽' : '—'),
              '💳 Комиссия WB: ' + (article.breakevenComm != null ? Math.round(article.breakevenComm) + ' ₽' : '—'),
              '🧾 Налог: ' + (article.breakevenTax != null ? Math.round(article.breakevenTax) + ' ₽' : '—'),
              '',
              '✅ Итого: ' + (article.breakevenPrice != null ? article.breakevenPrice + ' ₽' : '—'),
              '🔄 Обновляется каждый понедельник в 11:00 МСК',
            ].join('\n')}
              style={{fontSize:12,fontWeight:600,color:'var(--text)',textAlign:'center',padding:'1px 2px',display:'flex',flexDirection:'column',alignItems:'center',gap:1}}>
              <span>{article.breakevenPrice!=null?fmt(article.breakevenPrice):<span style={{color:'var(--border)',fontSize:10}}>—</span>}</span>
              {article.breakevenFbsPrice!=null&&<span style={{color:'#10b981',fontSize:10,fontWeight:600}}>{fmt(article.breakevenFbsPrice)}</span>}
            </div>
          </div>
          <div title={[
              '📦 Себес+ФФ: ' + (article.breakevenSeb != null ? Math.round(article.breakevenSeb) + ' ₽' : '—'),
              '🚚 Логистика: ' + (article.breakevenLog != null ? Math.round(article.breakevenLog) + ' ₽' : '—'),
              '🏪 Хранение: ' + (article.breakevenHran != null ? Math.round(article.breakevenHran) + ' ₽' : '—'),
              '💳 Комиссия WB: ' + (article.breakevenComm != null ? Math.round(article.breakevenComm) + ' ₽' : '—'),
              '🧾 Налог: ' + (article.breakevenTax != null ? Math.round(article.breakevenTax) + ' ₽' : '—'),
              '─────────────',
              '✅ Безубыточность: ' + (article.breakevenPrice != null ? article.breakevenPrice + ' ₽' : '—'),
              '📐 Аналитическая формула с учётом комиссии, налога, ИРП',
              '✅ М10%: ' + (article.margin10Price != null ? article.margin10Price + ' ₽' : '—'),
              '🔄 Обновляется каждый понедельник в 11:00 МСК',
            ].join('\n')} style={{width:widths.m10,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',cursor:'help'}}>
            <div style={{fontSize:12,fontWeight:600,color:'var(--text)',textAlign:'center',padding:'1px 2px',display:'flex',flexDirection:'column',alignItems:'center',gap:1}}>
              <span>{article.margin10Price!=null?fmt(article.margin10Price):<span style={{color:'var(--border)',fontSize:10}}>—</span>}</span>
              {article.margin10FbsPrice!=null&&<span style={{color:'#10b981',fontSize:10,fontWeight:600}}>{fmt(article.margin10FbsPrice)}</span>}
            </div>
          </div>
          <div title={[
              '📦 Себес+ФФ: ' + (article.breakevenSeb != null ? Math.round(article.breakevenSeb) + ' ₽' : '—'),
              '🚚 Логистика: ' + (article.breakevenLog != null ? Math.round(article.breakevenLog) + ' ₽' : '—'),
              '🏪 Хранение: ' + (article.breakevenHran != null ? Math.round(article.breakevenHran) + ' ₽' : '—'),
              '💳 Комиссия WB: ' + (article.breakevenComm != null ? Math.round(article.breakevenComm) + ' ₽' : '—'),
              '🧾 Налог: ' + (article.breakevenTax != null ? Math.round(article.breakevenTax) + ' ₽' : '—'),
              '─────────────',
              '✅ Безубыточность: ' + (article.breakevenPrice != null ? article.breakevenPrice + ' ₽' : '—'),
              '📐 Аналитическая формула с учётом комиссии, налога, ИРП',
              '✅ М22%: ' + (article.margin22Price != null ? article.margin22Price + ' ₽' : '—'),
              '🔄 Обновляется каждый понедельник в 11:00 МСК',
            ].join('\n')} style={{width:widths.m22,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',cursor:'help'}}>
            <div style={{fontSize:12,fontWeight:600,color:'var(--text)',textAlign:'center',padding:'1px 2px',display:'flex',flexDirection:'column',alignItems:'center',gap:1}}>
              <span>{article.margin22Price!=null?fmt(article.margin22Price):<span style={{color:'var(--border)',fontSize:10}}>—</span>}</span>
              {article.margin22FbsPrice!=null&&<span style={{color:'#10b981',fontSize:10,fontWeight:600}}>{fmt(article.margin22FbsPrice)}</span>}
            </div>
          </div>
          <div title={['✅ М27%: ' + (article.margin27Price != null ? article.margin27Price + ' ₽' : '—'), '🔄 Обновляется каждый понедельник в 11:00 МСК'].join('\n')}
            style={{width:widths.m27,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',cursor:'help'}}>
            <div style={{fontSize:12,fontWeight:600,color:'var(--text)',textAlign:'center',padding:'1px 2px',display:'flex',flexDirection:'column',alignItems:'center',gap:1}}>
              <span>{article.margin27Price!=null?fmt(article.margin27Price):<span style={{color:'var(--border)',fontSize:10}}>—</span>}</span>
              {article.margin27FbsPrice!=null&&<span style={{color:'#10b981',fontSize:10,fontWeight:600}}>{fmt(article.margin27FbsPrice)}</span>}
            </div>
          </div>
          <div style={{width:widths.comment,display:'flex',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',padding:'0 4px'}}>
            <input value={article.comment||''} onChange={e=>onCommentChange(article.nmId, e.target.value)} placeholder="Комментарий..." style={{width:'100%',background:'transparent',border:'none',color:'var(--text)',fontSize:11,outline:'none',textAlign:'left'}}/>
          </div>
          <div title={(() => {
              const vals = [article.buyoutW1, article.buyoutW2, article.buyoutW3, article.buyoutW4].filter(v => v != null);
              const buyout = vals.length > 0 ? vals.reduce((a,b) => a+b, 0) / vals.length : 0;
              const stock = Number(article.stockWbActive||0);
              const fbs = Number(article.stockFbs||0);
              const fromCl = Number(article.fromClient||0);
              const ff = Number(article.ffStockAfterOrders||0);
              const china = Number(article.chinaTransit||0);
              const total = stock + fbs + fromCl + ff + china;
              const result = article.buyoutPlan > 0 && article.ordersPlan > 0 && buyout > 0
                ? Math.round(total * 100 / buyout / article.ordersPlan) : 0;
              return [
                '📦 WB (без сгор.): ' + stock + ' шт',
                '📦 FBS: ' + fbs + ' шт',
                '←  От клиента: ' + fromCl + ' шт',
                '🏭 ФФ после заказов: ' + ff + ' шт',
                '🚢 Китай: ' + china + ' шт',
                '─────────────',
                '📊 Итого остаток: ' + total + ' шт',
                '🔄 % выкупа (W1-W4): ' + (buyout > 0 ? buyout.toFixed(1) : '—') + '%',
                '📅 Делитель (план): ' + (article.ordersPlan || '—') + ' дней',
                '─────────────',
                '📐 Формула: ' + total + ' × 100 / ' + buyout.toFixed(1) + ' / ' + article.ordersPlan,
                '✅ План/день: ' + result + ' штук',
              ].join('\n');
            })()} style={{width:widths.ordersPlan,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',borderRight:'1px solid var(--border)',position:'relative',height:'100%',cursor:'help'}}>
            <div style={{position:'absolute',top:2,background:'rgba(59,130,246,0.12)',border:'1px solid rgba(59,130,246,0.3)',borderRadius:4,padding:'1px 5px',fontSize:9,color:'#60a5fa'}}>
              <EditCell nmId={article.nmId} field="buyout_plan" value={article.ordersPlan} onSaved={onSaved}/>
            </div>
            <div style={{fontSize:13,fontWeight:700,color:'var(--text)'}}>
              {(() => {
                const vals = [article.buyoutW1, article.buyoutW2, article.buyoutW3, article.buyoutW4].filter(v => v != null);
                const buyout = vals.length > 0 ? vals.reduce((a,b) => a+b, 0) / vals.length : 0;
                return article.buyoutPlan > 0 && article.ordersPlan > 0 && buyout > 0
                  ? Math.round((Number(article.stockWbActive||0) + Number(article.stockFbs||0) + Number(article.fromClient||0) + Number(article.ffStockAfterOrders||0) + Number(article.chinaTransit||0)) * 100 / buyout / article.ordersPlan)
                  : 0;
              })()}
            </div>
          </div>
          <div style={{width:widths.labels,display:'flex',flexDirection:'column',justifyContent:'flex-start',padding:'3px 4px'}}>
            {ROW_LABELS.map((l,i)=>(
              l===''?<div key={i} style={{height:16}}/>:
              l==='+ размеры'?
                <button key={i} onClick={()=>setExpanded(x=>!x)} style={{background:'transparent',border:'1px solid var(--border)',color:'var(--text-muted)',borderRadius:4,padding:'0 5px',fontSize:9,cursor:'pointer',height:16,lineHeight:'16px',alignSelf:'flex-start',marginTop:1}}>
                  {expanded?'− свернуть':'+ размеры'}
                </button>

              :
              <div key={i} style={{fontSize:9,color:'rgba(255,255,255,0.92)',height:16,lineHeight:'16px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{l}</div>
            ))}
          </div>
        </div>
        {dates.map(date=>{
          const isYesterday = date === toISO(addDays(new Date(), -1));
          const d=article.daily?.[date];
          const qty=d?.orders_qty||0;
          const spp=d?.spp_pct||null;
          const fdrr=calcFdrr(d);
          return(
            <div key={date} style={{width:CELL_W,borderRight: isYesterday ? '1px solid rgba(16,185,129,0.2)' : '1px solid var(--border)',padding:'3px 4px',flexShrink:0,borderTop:'1px solid rgba(255,255,255,0.03)', background: isYesterday ? 'rgba(16,185,129,0.05)' : 'transparent'}}>
              <div style={{height:16,lineHeight:'16px',fontSize:11,fontWeight:700,textAlign:'right',color:ordersColor(qty),borderBottom:'1px solid rgba(255,255,255,0.1)',display:'flex',alignItems:'center',justifyContent:'flex-end',gap:3,position:'relative'}}>
                <HypothesisTooltip nmId={article.nmId} date={date} hypoData={hypoData} filterTypes={['card_update','stock','manual']}/>
                {qty}
              </div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:'var(--text)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{d?.price?fmt(d.price):'—'}</div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:'var(--text-muted)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{spp?fmtPct(spp):'—'}</div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:'var(--text-muted)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>
                {d?.price&&d?.spp_pct?fmt(Math.round(d.price*(1-d.spp_pct/100))):'—'}
              </div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:'var(--text)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{d?.orders_sum?fmt(d.orders_sum):'—'}</div>
              <div onDoubleClick={()=>toggleAdMark(article.nmId, date)} title={adMarks[String(article.nmId)]?.[date]==='red'?'1К':adMarks[String(article.nmId)]?.[date]==='blue'?'2К':''}
                style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',cursor:'pointer',borderBottom:'1px solid rgba(255,255,255,0.1)',
                  background: adMarks[String(article.nmId)]?.[date] === 'red' ? 'rgba(239,68,68,0.2)' : adMarks[String(article.nmId)]?.[date] === 'blue' ? 'rgba(59,130,246,0.2)' :
                              adMarks[String(article.nmId)]?.[toISO(new Date())] && date === toISO(new Date()) ? 'rgba(239,68,68,0.08)' : 'transparent',
                  color: adMarks[String(article.nmId)]?.[date] === 'red' ? '#ef4444' : adMarks[String(article.nmId)]?.[date] === 'blue' ? '#60a5fa' :
                         adMarks[String(article.nmId)]?.[toISO(new Date())] && date === toISO(new Date()) ? 'rgba(239,68,68,0.5)' :
                         d?.spend_all>0?'var(--yellow)':'var(--text-muted)',
                  fontWeight: adMarks[String(article.nmId)]?.[date] ? 700 : 400,
                }}>{d?.spend_all?fmt(d.spend_all):'—'}</div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:d?.drr>30?'var(--red)':d?.drr>0?'var(--text)':'var(--text-muted)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{d?.drr?fmtPct(d.drr):'—'}</div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',color:'var(--text-muted)',borderBottom:'1px solid rgba(255,255,255,0.1)'}}>{fdrr?fmtPct(fdrr):'—'}</div>
              <div style={{height:16,lineHeight:'16px',fontSize:10,textAlign:'right',borderBottom:'1px solid rgba(255,255,255,0.1)',color:(()=>{
                const yesterday=toISO(addDays(todayMSK(),-1));
                if(date>yesterday)return'var(--text-muted)';
                const m=d?.margin_no_rk!=null?Number(d.margin_no_rk):null;const f=fdrr;
                if(m==null||f==null||!isFinite(m-f))return'var(--text-muted)';
                const res=m-f;return res>0?'var(--green)':res>-5?'var(--yellow)':'var(--red)';
              })()}}>
                {(()=>{
                  const yesterday=toISO(addDays(todayMSK(),-1));
                  if(date>yesterday)return<span style={{color:'var(--text-muted)'}}>—</span>;
                  const m=d?.margin_no_rk!=null?Number(d.margin_no_rk):null;const f=fdrr;
                  if(m==null||f==null||!isFinite(m-f))return<span style={{color:'var(--text-muted)'}}>—</span>;
                  const res=Math.round((m-f)*100)/100;
                  return res+'%';
                })()}
              </div>
              <div style={{height:16}}/>
              <div style={{height:16}}/>
              <div style={{height:16}}/>
            </div>
          );
        })}
      </div>
      {expanded&&(
        <div style={{borderTop:'1px dashed rgba(59,130,246,0.2)',background:'#0a0f1a',position:'relative',zIndex:3,isolation:'isolate'}}>
          <div style={{display:'flex'}}>
            <div style={{display:'flex',width:fixedW,flexShrink:0,position:'sticky',left:0,zIndex:2,background:fixedBg,borderRight:'2px solid var(--border)'}}>
              {[{w:widths.photo,l:''},{w:widths.article,l:'Размер'},{w:widths.stockWbActive,l:'WB*'},{w:widths.stockFbs,l:'FBS*'},{w:widths.toClient,l:'→Кл'},{w:widths.fromClient,l:'←Кл'},{w:widths.ffStockAfterOrders,l:'ФФ-зак'},{w:widths.china,l:'Китай'},{w:widths.buyoutWeeks,l:'% выкупа'},{w:widths.breakeven+widths.m10+widths.m22+widths.m27+widths.comment+widths.ordersPlan+widths.labels,l:''}].map((c,i)=>(
                <div key={i} style={{width:c.w,flexShrink:0,fontSize:8,fontWeight:700,color:'var(--text-muted)',textAlign:'center',padding:'2px 2px',borderRight:'1px solid var(--border)',textTransform:'uppercase',background:'rgba(59,130,246,0.08)'}}>{c.l}</div>
              ))}
            </div>
            {dates.map(date=>(<div key={date} style={{width:CELL_W,flexShrink:0,height:20,borderRight:'1px solid var(--border)',background:'rgba(59,130,246,0.08)'}}/>))}
          </div>
          {/* Размеры + конверсии параллельно */}
          {(() => {
            const convRows = [
              { label:'Показы',              fn: d=>d?.impressions||null,   fmt: v=>String(v) },
              { label:'Переходы',            fn: d=>d?.open_count||null,    fmt: v=>String(v) },
              { label:'CTR',                 fn: d=>d?.ctr!=null?Number(d.ctr):null, fmt: v=>v+'%' },
              { label:'Корзины',             fn: d=>d?.cart_count||null,    fmt: v=>String(v) },
              { label:'Конв. клик→корзина',  fn: d=>d?.conv_tr_cart!=null?Number(d.conv_tr_cart):(d?.open_count&&d?.cart_count?Math.round(d.cart_count/d.open_count*100*10)/10:null), fmt: v=>v+'%' },
              { label:'Конв. корзина→заказ', fn: d=>d?.conv_cart_ord!=null?Number(d.conv_cart_ord):(d?.cart_count&&d?.orders_qty?Math.round(d.orders_qty/d.cart_count*100*10)/10:null), fmt: v=>v+'%' },
              { label:'Конв. показ→заказ',   fn: d=>(d?.impressions&&d?.orders_qty)?Math.round(d.orders_qty/d.impressions*100*100)/100:null, fmt: v=>v+'%' },
            ];
            const maxRows = Math.max(sizes.length, convRows.length);
            return Array.from({length: maxRows}, (_,ri) => {
              const size = sizes[ri] || null;
              const conv = convRows[ri] || null;
              return (
                <div key={'sr'+ri} style={{display:'flex',borderTop:'1px solid rgba(255,255,255,0.04)',background:'#0a0f1a'}}>
                  <div style={{display:'flex',width:fixedW,flexShrink:0,position:'sticky',left:0,zIndex:2,background:fixedBg,borderRight:'2px solid var(--border)'}}>
                    <div style={{width:widths.photo,flexShrink:0,borderRight:'1px solid var(--border)'}}/>
                    <div style={{width:widths.article,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'var(--accent)'}}>{size||''}</div>
                    <div style={{width:widths.stockWbActive,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11}}>{size?getSizeVal(article.stockWbActiveSizes,size):''}</div>
                    <div style={{width:widths.stockFbs,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,color:'#10b981'}}>{size?getSizeVal(article.stockFbsSizes,size):''}</div>
                    <div style={{width:widths.toClient,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11}}>{size?getSizeVal(article.toClientSizes,size):''}</div>
                    <div style={{width:widths.fromClient,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11}}>{size?getSizeVal(article.fromClientSizes,size):''}</div>
                    <div style={{width:widths.ffStockAfterOrders,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,color:size&&getSizeVal(article.ffStockSizes,size)>0?'var(--green)':'var(--text-muted)'}}>{size?getSizeVal(article.ffStockSizes,size):''}</div>
                    <div style={{width:widths.china,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,color:size&&getSizeVal(article.chinaTransitSizes,size)>0?'var(--accent)':'var(--text-muted)'}}>{size?getSizeVal(article.chinaTransitSizes,size):''}</div>
                    <div style={{width:widths.buyoutWeeks,flexShrink:0,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10}}>
                      {size&&(()=>{const val=article.buyoutSizes?.[size];return val!=null?<span style={{color:val>=50?'var(--green)':val>=30?'var(--yellow)':'var(--red)',fontWeight:700}}>{val}%</span>:<span style={{color:'var(--text-muted)'}}>—</span>;})()}
                    </div>
                    <div style={{width:widths.breakeven+widths.m10+widths.m22+widths.m27+widths.ordersPlan,flexShrink:0}}/>
                    <div style={{width:widths.labels,flexShrink:0,display:'flex',alignItems:'center',paddingLeft:4,fontSize:9,fontWeight:600,color:'rgba(165,180,252,0.9)',whiteSpace:'nowrap',overflow:'hidden',background:conv?'rgba(99,102,241,0.05)':'transparent'}}>{conv?conv.label:''}</div>
                  </div>
                  {dates.map(date=>{
                    const d=article.daily?.[date];
                    const val=conv?conv.fn(d):null;
                    return <div key={date} style={{width:CELL_W,flexShrink:0,height:24,borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,color:val!=null?'rgba(200,215,235,0.85)':'rgba(200,215,235,0.2)',background:'var(--bg)'}}>
                      {val!=null?conv.fmt(val):'—'}
                    </div>;
                  })}
                </div>
              );
            });
          })()}
        </div>
      )}
    </div>
  );
}

// ─── Заголовок таблицы ───────────────────────────────────────────
function TableHeader({dates, widths, startResize, buyoutWeeks=[], sortConfig={}, onSort=()=>{}}) {
  const fixedW = Object.entries(widths).reduce((a,[k,b])=>k==='stockWb'?a:a+b,0);
  const cols = [
    {k:'photo',l:'Фото',sk:null},{k:'article',l:'Артикул',sk:'vendorCode'},
    {k:'stockWbActive',l:'WB (без сгор.)',sk:'stockWbActive'},{k:'stockFbs',l:'Остаток FBS',sk:'stockFbs'},{k:'toClient',l:'→ Клиент',sk:'toClient'},
    {k:'fromClient',l:'← Клиент',sk:'fromClient'},{k:'ffStockAfterOrders',l:'ФФ после заказов',sk:'ffStockAfterOrders'},
    {k:'china',l:'Китай',sk:'chinaTransit'},
    {k:'buyoutWeeks',l:'% выкупа понедельно',sk:null},{k:'breakeven',l:'Безубыт.',sk:'breakevenPrice'},
    {k:'m10',l:'М 10%',sk:'margin10Price'},{k:'m22',l:'М 22%',sk:'margin22Price'},{k:'m27',l:'М 27%',sk:'margin27Price'},{k:'comment',l:'Комментарий',sk:null},
    {k:'ordersPlan',l:'План/день',sk:'ordersPlan'},{k:'labels',l:'',sk:null},
  ];
  return(
    <div style={{display:'flex',position:'sticky',top:0,zIndex:10,background:'var(--sidebar)',borderBottom:'2px solid var(--border)',userSelect:'none'}}>
      <div style={{display:'flex',width:fixedW,flexShrink:0,position:'sticky',left:0,zIndex:11,background:'var(--sidebar)',borderRight:'2px solid var(--border)'}}>
        {cols.map(col=>(
          <div key={col.k} onClick={col.sk?()=>onSort(col.sk):undefined}
            style={{width:widths[col.k],padding:'3px 2px',borderRight:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',position:'relative',overflow:'hidden',textAlign:'center',cursor:col.sk?'pointer':'default',background:sortConfig.key===col.sk?'rgba(59,130,246,0.08)':'transparent'}}>
            <span style={{overflow:'hidden',textOverflow:'ellipsis',fontSize:7,lineHeight:'1.2',textAlign:'center',whiteSpace:'normal',wordBreak:'break-word',color:'var(--text-muted)',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.3px'}}>{col.l}</span>
            {col.sk&&<span style={{marginLeft:1,fontSize:6,color:sortConfig.key===col.sk?'var(--accent)':'var(--border)',flexShrink:0}}>{sortConfig.key===col.sk?(sortConfig.dir===1?'▲':'▼'):'⇅'}</span>}
            <div onMouseDown={e=>{e.stopPropagation();startResize(col.k,e);}} style={{position:'absolute',right:0,top:0,bottom:0,width:4,cursor:'col-resize'}}/>
          </div>
        ))}
      </div>
      {dates.map(date=>{
        const isYesterday = date === new Date(Date.now() - 86400000).toISOString().split('T')[0];
        return (
          <div key={date} onClick={()=>onSort('date:'+date)}
            style={{width:CELL_W,textAlign:'center',padding:'5px 2px',borderRight:'1px solid var(--border)',flexShrink:0,fontSize:9,fontWeight:700,
            cursor:'pointer',position:'relative',
            color: sortConfig.key==='date:'+date ? 'var(--accent)' : isYesterday ? '#10b981' : 'var(--text-muted)',
            background: sortConfig.key==='date:'+date ? 'rgba(59,130,246,0.08)' : isYesterday ? 'rgba(16,185,129,0.08)' : 'transparent',
            borderBottom: isYesterday ? '2px solid rgba(16,185,129,0.4)' : undefined,
          }}>
            {fmtDate(date)}{sortConfig.key==='date:'+date?<span style={{fontSize:6,marginLeft:2}}>{sortConfig.dir===1?'▲':'▼'}</span>:null}
          </div>
        );
      })}
    </div>
  );
}

function TableContainer({dates, articles, widths, startResize, buyoutWeeks, sortConfig, onSort, onSaved, loading, lastSync, favorites=new Set(), onToggleFavorite, hidden=new Set(), toggleHidden=()=>{}, showHidden=false, tags={}, tagFilter='all', handleTag=()=>{}, savedScroll=0, onScroll, adMarks={}, toggleAdMark=()=>{}, lastAdDate='', search='', onCommentChange=()=>{}}) {
  const hypoData = useHypothesisData(dates);
  const fixedW = Object.entries(widths).reduce((a,[k,b])=>k==='stockWb'?a:a+b,0);
  const scrollRef = useRef();
  const [visibleCount, setVisibleCount] = useState(50);

  useEffect(() => {
    if (scrollRef.current) {
      if (savedScroll) scrollRef.current.scrollTop = savedScroll;
      // Прокручиваем вправо до конца (новые даты)
      setTimeout(() => {
        if (scrollRef.current) scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
      }, 50);
    }
  }, []);

  // Сбрасываем visibleCount при смене данных
  useEffect(() => { setVisibleCount(50); }, [articles.length, dates.join(',')]);

  const handleScroll = (e) => {
    const el = e.currentTarget;
    if (onScroll) onScroll(el.scrollTop);
    // Подгружаем ещё строки когда доскроллили до конца
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 500) {
      setVisibleCount(prev => Math.min(prev + 50, articles.length));
    }
  };

  return (
    <div ref={scrollRef} style={{width:'100%',height:'100%',overflow:'auto'}}
      data-table-scroll="" data-scroll-container=""
      onScroll={handleScroll}>
      <div style={{minWidth: fixedW + dates.length * CELL_W}}>
        <TableHeader dates={dates} widths={widths} startResize={startResize}
          buyoutWeeks={buyoutWeeks} sortConfig={sortConfig} onSort={onSort}/>
        {articles.length===0&&!loading&&(
          <div style={{padding:32,textAlign:'center',color:'var(--text-muted)',fontSize:13}}>
            {lastSync?'Нет данных за период':'Нажмите "↻ Синхр. WB" для загрузки данных'}
          </div>
        )}
        {articles.filter(a => {
          if (showHidden ? !hidden.has(String(a.nmId)) : hidden.has(String(a.nmId))) return false;
          if (tagFilter === 'ad') { return adMarks[String(a.nmId)]?.[lastAdDate]; }
          if (tagFilter !== 'all' && tags[String(a.nmId)] !== tagFilter) return false;
          return true;
        }).sort((a, b) => {
          if (tagFilter === 'ad') {
            const ca = adMarks[String(a.nmId)]?.[lastAdDate];
            const cb = adMarks[String(b.nmId)]?.[lastAdDate];
            if (ca === 'blue' && cb !== 'blue') return -1;
            if (cb === 'blue' && ca !== 'blue') return 1;
          }
          return 0;
        }).slice(0, visibleCount).map((a,i)=>(
          <ArticleRow key={a.nmId} article={a} dates={dates} adMarks={adMarks} toggleAdMark={toggleAdMark} onCommentChange={onCommentChange}
            searchMatch={search && ((a.vendorCode||'').toLowerCase().includes(search.toLowerCase()) || String(a.nmId).includes(search))}
            onSaved={onSaved} isOdd={i%2===1} widths={widths}
            buyoutWeeks={buyoutWeeks} fixedW={fixedW}
            isFavorite={favorites.has(String(a.nmId))}
            onToggleFavorite={onToggleFavorite}
            onHide={toggleHidden}
            onTag={handleTag}
            tag={tags[String(a.nmId)]||''} hypoData={hypoData}/>
        ))}
      </div>
    </div>
  );
}

export default function Monitoring() {
  const { saved, save } = usePageState('monitoring');
  const today = new Date();

  // Восстанавливаем все состояния из кеша
  const initFrom = saved?.from || toISO(addDays(today,-29));
  const initTo   = toISO(today); // всегда сегодня

  const [from, setFrom] = useState(initFrom);
  const [to,   setTo]   = useState(initTo);
  const [data, setData] = useState(null);
  const [articles, setArticles] = useState([]);
  const commentTimer = useRef({});
  const onCommentChange = (nmId, value) => {
    setArticles(prev => prev.map(a => a.nmId === nmId ? {...a, comment: value} : a));
    if (commentTimer.current[nmId]) clearTimeout(commentTimer.current[nmId]);
    commentTimer.current[nmId] = setTimeout(() => {
      api.post('/monitoring/comment', { nmId, comment: value }).catch(()=>{});
    }, 1500);
  };
  const [loading,  setLoading]  = useState(false);
  const [syncing,  setSyncing]  = useState(false);
  const [error,    setError]    = useState(null);
  const [syncMsg,  setSyncMsg]  = useState(null);
  const [syncLimits, setSyncLimits] = useState(saved?.syncLimits || { used:0, limit:10 });
  const [favorites, setFavorites] = useState(new Set());
  const [hidden, setHidden] = useState(new Set());
  const [showHidden, setShowHidden] = useState(false);

  // Загружаем скрытые из БД
  useEffect(() => {
    api.get('/monitoring/hidden').then(r => {
      setHidden(new Set(r.data.map(String)));
    }).catch(() => {});
  }, []);
  const [tags, setTags] = useState({});
  const [tagFilter, setTagFilter] = useState('all'); // all | top | flop
  const [blurIds, setBlurIds] = React.useState(() => localStorage.getItem('bystats_blur_ids') === '1');
  const [syncingFbs, setSyncingFbs] = React.useState(false);
  const [fbsSyncStatus, setFbsSyncStatus] = React.useState(''); // '', 'loading', 'done', 'error'
  const handleSyncFbs = async () => {
    setSyncingFbs(true);
    setFbsSyncStatus('loading');
    try {
      const r = await api.post('/monitoring/sync-fbs');
      setSyncingFbs(false);
      if (r.data.ok) {
        setFbsSyncStatus('done');
        setTimeout(() => setFbsSyncStatus(''), 10000);
      } else {
        setFbsSyncStatus('error');
        setTimeout(() => setFbsSyncStatus(''), 5000);
      }
    } catch(e) {
      setSyncingFbs(false);
      setFbsSyncStatus('error');
      setTimeout(() => setFbsSyncStatus(''), 5000);
    }
  };
  const toggleBlur = () => setBlurIds(v => { const n=!v; localStorage.setItem('bystats_blur_ids', n?'1':'0'); if(n) document.body.classList.add('blur-wb-ids'); else document.body.classList.remove('blur-wb-ids'); return n; });
  React.useEffect(() => { if(blurIds) document.body.classList.add('blur-wb-ids'); }, []);
  const [search, setSearch] = useState('');
  const [adMarks, setAdMarks] = useState({}); // { nmId: { 'YYYY-MM-DD': true } }

  useEffect(() => {
    api.get('/monitoring/ad-marks').then(r => {
      const map = {};
      (r.data || []).forEach(m => {
        const id = String(m.nm_id);
        if (!map[id]) map[id] = {};
        const date = (m.mark_date||'').split('T')[0];
        map[id][date] = m.color || 'red';
      });
      setAdMarks(map);
    }).catch(()=>{});
  }, []);

  const toggleAdMark = async (nmId, date) => {
    const id = String(nmId);
    const today = new Date(Date.now() + 3*3600000).toISOString().split('T')[0];
    if (date !== today) return; // можно отмечать только сегодня
    const current = adMarks[id]?.[date];
    if (current === 'blue') {
      await api.delete('/monitoring/ad-mark/' + id).catch(()=>{});
      setAdMarks(prev => { const n = {...prev}; if (n[id]) delete n[id][date]; return n; });
    } else if (current === 'red') {
      await api.post('/monitoring/ad-mark/' + id, { color: 'blue' }).catch(()=>{});
      setAdMarks(prev => ({ ...prev, [id]: { ...(prev[id]||{}), [date]: 'blue' } }));
    } else {
      await api.post('/monitoring/ad-mark/' + id, { color: 'red' }).catch(()=>{});
      setAdMarks(prev => ({ ...prev, [id]: { ...(prev[id]||{}), [date]: 'red' } }));
    }
  };
  const handleTag = async (nmId) => {
    const id = String(nmId);
    const cur = tags[id] || '';
    const next = cur === '' ? 'top' : cur === 'top' ? 'flop' : '';
    // Сохраняем позицию скролла
    const scrollEl = document.querySelector('[data-table-scroll]');
    const scrollTop = scrollEl?.scrollTop || 0;
    const scrollLeft = scrollEl?.scrollLeft || 0;
    setTags(prev => ({ ...prev, [id]: next }));
    // Восстанавливаем позицию после рендера
    requestAnimationFrame(() => {
      if (scrollEl) { scrollEl.scrollTop = scrollTop; scrollEl.scrollLeft = scrollLeft; }
    });
    await api.post(`/monitoring/tags/${id}`, { tag: next });
  };
  const toggleHidden = (nmId) => setHidden(prev => {
    const next = new Set(prev);
    next.has(String(nmId)) ? next.delete(String(nmId)) : next.add(String(nmId));
    if (next.has(String(nmId))) {
      api.post('/monitoring/hidden/' + nmId).catch(() => {});
    } else {
      api.delete('/monitoring/hidden/' + nmId).catch(() => {});
    }
    return next;
  });
  const [widths, startResize] = useColWidths(DEFAULT_WIDTHS);
  const [buyoutWeeks, setBuyoutWeeks] = useState([]);
  const yesterday0 = new Date(Date.now()+3*3600000-86400000).toISOString().split('T')[0];
  const [sortConfig, setSortConfig] = useState(saved?.sortConfig || {key:'date:'+yesterday0, dir:-1});
  const [catGif] = useState(() => getSmartCatGif());

  const saveRef = useRef(save);
  saveRef.current = save;
  const savedRef = useRef(saved);
  savedRef.current = saved;

  const handleSort = (key) => {
    setSortConfig(prev => {
      const next = {key, dir: prev.key===key ? -prev.dir : -1};
      saveRef.current({...savedRef.current, sortConfig: next});
      return next;
    });
  };

  const load = useCallback(async(f,t,forceReload=false) => {
    const cached = savedRef.current;
    if (!forceReload && cached && cached.from===f && cached.to===t && cached.data) {
      // Проверяем актуальность кеша — делаем быстрый запрос lastSync
      try {
        const check = await api.get('/monitoring/cache-status');
        const serverSync = check.data.lastSync;
        const serverDaily = check.data.dailyLastDate;
        if (serverSync && cached.lastSync && serverSync === cached.lastSync &&
            serverDaily && cached.dailyLastDate && serverDaily === cached.dailyLastDate) {
          setData(cached.data);
          setArticles(cached.data.articles||[]);
          setBuyoutWeeks(cached.data.buyoutWeeks||[]);
          setFavorites(new Set((cached.favorites||[]).map(String)));
          setSyncLimits(cached.syncLimits||{used:0,limit:10});
          if (cached.sortConfig) setSortConfig(cached.sortConfig);
          return;
        }
        // lastSync изменился — сбрасываем кеш
        console.log('Кеш устарел, перезагружаем...');
      } catch(e) {}
    }
    setLoading(true); setError(null);
    try {
      const r = await api.get(`/monitoring/data?from=${f}&to=${t}`);
      const [favRes, tagsRes, limRes] = await Promise.allSettled([
        api.get('/monitoring/favorites'),
        api.get('/monitoring/tags'),
        api.get('/monitoring/cache-status'),
      ]);
      const favs = favRes.status==='fulfilled' ? favRes.value.data : [];
      const tagsData = tagsRes.status==='fulfilled' ? tagsRes.value.data : {};
      const lims = limRes.status==='fulfilled' ? {used:limRes.value.data.used||0,limit:limRes.value.data.limit||10} : {used:0,limit:10};
      const tagsMap = tagsData;
      setData(r.data); setArticles(r.data.articles||[]); setBuyoutWeeks(r.data.buyoutWeeks||[]);
      setFavorites(new Set(favs.map(String)));
      setTags(tagsMap);
      setSyncLimits(lims);
      saveRef.current({...savedRef.current, from:f, to:t, data:r.data, favorites:favs, syncLimits:lims, lastSync:r.data.lastSync});
    } catch(e) { setError(e.response?.data?.error||e.message); }
    finally { setLoading(false); }
  },[]);

  useEffect(()=>{ load(initFrom, initTo); },[]);

  const handleDateChange=(f,t,m)=>{
    setFrom(f); setTo(t);
    saveRef.current({...savedRef.current, from:f, to:t, dateMode:m});
    load(f,t,true).then(()=>{
      setTimeout(()=>{
        const el = document.querySelector('[data-table-scroll]');
        if (el) el.scrollLeft = el.scrollWidth;
      }, 300);
    });
  };

  const [syncRunning, setSyncRunning] = useState(false);
  const [syncBlockSecs, setSyncBlockSecs] = useState(0);
  const handleSync = async() => {
    setSyncing(true); setSyncMsg(null);
    try {
      const r = await api.post('/monitoring/sync');
      if (r.data.used != null) setSyncLimits({ used: r.data.used, limit: r.data.limit||10 });
      if (r.data.ok) {
        setSyncRunning(true);
        // Блокируем кнопку на 15 минут
        let blockSecs = 900;
        setSyncBlockSecs(blockSecs);
        const blockTimer = setInterval(() => {
          blockSecs--;
          setSyncBlockSecs(blockSecs);
          if (blockSecs <= 0) clearInterval(blockTimer);
        }, 1000);
        // Проверяем каждые 15 сек обновились ли данные
        const startTime = Date.now();
        // Запоминаем начальное кол-во записей за сегодня
        let initialCount = 0;
        try {
          const s = await api.get('/monitoring/cache-status');
          initialCount = s.data?.todayCount || 0;
        } catch(e) {}

        const checkDone = setInterval(async () => {
          try {
            const status = await api.get('/monitoring/cache-status');
            const newCount = status.data?.todayCount || 0;
            // Если записей стало больше — синхронизация завершена
            if (newCount > initialCount) {
              clearInterval(checkDone);
              setSyncRunning(false);
              setSyncMsg('done');
            }
            // Максимум 10 минут
            if (Date.now() - startTime > 600000) {
              clearInterval(checkDone);
              setSyncRunning(false);
              setSyncMsg('done');
            }
          } catch(e) {}
        }, 15000);
      } else {
        setSyncMsg(r.data.message);
      }
    } catch(e) { setSyncMsg('Ошибка: '+(e.response?.data?.error||e.message)); }
    finally { setSyncing(false); }
  };

  const handleSaved=(nmId,field,value)=>{
    setArticles(prev=>prev.map(a=>{
      if (String(a.nmId)!==String(nmId)) return a;
      const updated = {...a,[snakeToCamel(field)]:value};
      // При изменении buyout_plan обновляем ordersPlan тоже
      if (field === 'buyout_plan') updated.ordersPlan = value || 0;
      return updated;
    }));
  };

  const searchLower = search.toLowerCase();
  useEffect(() => {
    if (!search) return;
    const el = document.querySelector('[data-article-row]');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [search]);
  const today2 = new Date(Date.now() + 3*3600000).toISOString().split('T')[0];
  const yesterday2 = new Date(Date.now() + 3*3600000 - 86400000).toISOString().split('T')[0];
  // Последняя дата отметок рекламы
  const allAdDates = Object.values(adMarks).flatMap(d => Object.keys(d));
  const lastAdDate = allAdDates.length > 0 ? allAdDates.sort().reverse()[0] : today2;
  const filteredBySearch = articles.filter(a => {
    if (tagFilter === 'ad') return adMarks[String(a.nmId)]?.[lastAdDate];
    if (search) {
      const s = search.toLowerCase();
      return (a.vendorCode||'').toLowerCase().includes(s) || String(a.nmId).includes(search);
    }
    return true;
  });

  const sortedArticles = [...filteredBySearch].sort((a,b) => {
    const aFav = favorites.has(String(a.nmId)) ? 1 : 0;
    const bFav = favorites.has(String(b.nmId)) ? 1 : 0;
    if (aFav !== bFav) return bFav - aFav;
    if (!sortConfig.key) return 0;
    const k = sortConfig.key;
    let av, bv;
    if (k.startsWith('date:')) {
      const d = k.slice(5);
      av = Number(a.daily?.[d]?.orders_qty || 0);
      bv = Number(b.daily?.[d]?.orders_qty || 0);
    } else {
      av = k==='vendorCode' ? (a[k]||'') : (Number(a[k])||0);
      bv = k==='vendorCode' ? (b[k]||'') : (Number(b[k])||0);
    }
    if (av < bv) return -sortConfig.dir;
    if (av > bv) return sortConfig.dir;
    return 0;
  });

  return(
    <div style={{height:'100vh',display:'flex',flexDirection:'column',background:'var(--bg)',overflow:'hidden'}}>
      <div style={{padding:'12px 16px',borderBottom:'1px solid var(--border)',background:'rgba(13,18,30,0.6)',backdropFilter:'blur(16px)',WebkitBackdropFilter:'blur(16px)',display:'flex',alignItems:'center',gap:12,flexShrink:0,position:'relative',zIndex:50}}>
        {/* Левая часть — заголовок + фильтры в 2 строки */}
        <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:'var(--text)',whiteSpace:'nowrap'}}>Мониторинг</div>
            <div style={{fontSize:10,color:'var(--text-muted)',marginTop:2}}>{articles.length-hidden.size} арт.{data?.dates&&` · ${data.dates.length} дн.`}</div>
          </div>
          <div style={{width:1,height:36,background:'rgba(255,255,255,0.1)',flexShrink:0}}/>
          {/* Две строки кнопок */}
          <div style={{display:'grid',gridTemplateColumns:'auto 1px minmax(90px,auto) 1px auto',gridTemplateRows:'1fr 1fr',alignItems:'stretch',border:'1px solid rgba(255,255,255,0.1)',borderRadius:5,overflow:'hidden'}}>
            <button onClick={()=>setTagFilter('all')} style={{gridColumn:1,gridRow:1,padding:'2px 12px',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='all'?700:400,background:tagFilter==='all'?'rgba(59,130,246,0.2)':'transparent',border:'none',borderBottom:'1px solid rgba(255,255,255,0.1)',color:tagFilter==='all'?'#60a5fa':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>★ Все{(articles.length-hidden.size)>0?` (${articles.length-hidden.size})`:''}</button>
            <button onClick={()=>setShowHidden(s=>!s)} style={{gridColumn:1,gridRow:2,padding:'2px 12px',fontSize:11,cursor:'pointer',fontWeight:showHidden?700:400,background:showHidden?'rgba(239,68,68,0.15)':'transparent',border:'none',color:showHidden?'#ef4444':'rgba(200,215,235,0.4)',whiteSpace:'nowrap'}}>{showHidden?`✕ скрыть (${hidden.size})`:`○ скрытые (${hidden.size})`}</button>
            <div style={{gridColumn:2,gridRow:'1/3',background:'rgba(255,255,255,0.1)'}}/>
            <button onClick={()=>setTagFilter('top')} style={{gridColumn:3,gridRow:1,padding:'2px 12px',textAlign:'left',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='top'?700:400,background:tagFilter==='top'?'rgba(16,185,129,0.2)':'transparent',border:'none',borderBottom:'1px solid rgba(255,255,255,0.1)',color:tagFilter==='top'?'#10b981':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>▲ Топ{Object.values(tags).filter(t=>t==='top').length>0?` (${Object.values(tags).filter(t=>t==='top').length})`:''}</button>
            <button onClick={()=>setTagFilter('flop')} style={{gridColumn:3,gridRow:2,padding:'2px 12px',textAlign:'left',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='flop'?700:400,background:tagFilter==='flop'?'rgba(239,68,68,0.2)':'transparent',border:'none',color:tagFilter==='flop'?'#ef4444':'rgba(200,215,235,0.5)',whiteSpace:'nowrap'}}>▼ Слив{Object.values(tags).filter(t=>t==='flop').length>0?` (${Object.values(tags).filter(t=>t==='flop').length})`:''}</button>
            <div style={{gridColumn:4,gridRow:'1/3',background:'rgba(255,255,255,0.1)'}}/>
            <button onClick={()=>setTagFilter('ad')} style={{gridColumn:5,gridRow:'1/3',padding:'3px 12px',fontSize:11,cursor:'pointer',fontWeight:tagFilter==='ad'?700:400,background:tagFilter==='ad'?'rgba(239,68,68,0.2)':'transparent',border:'none',color:tagFilter==='ad'?'#ef4444':'rgba(200,215,235,0.5)',whiteSpace:'nowrap',display:'flex',alignItems:'center'}}>{(()=>{const cnt=Object.keys(adMarks).filter(id=>adMarks[id]?.[lastAdDate]).length;const isToday=lastAdDate===new Date(Date.now()+3*3600000).toISOString().split('T')[0];const dateLabel=isToday?'сегодня':lastAdDate===new Date(Date.now()+3*3600000-86400000).toISOString().split('T')[0]?'вчера':lastAdDate;const dateColor=isToday?'#10b981':'#ef4444';return(<><span>📢 Реклама</span>{cnt>0&&<span style={{marginLeft:4}}>({cnt}) <span style={{fontSize:10,color:dateColor}}>{dateLabel}</span></span>}</>);})()}</button>
          </div>
        </div>
        <div style={{width:1,height:36,background:'rgba(255,255,255,0.1)',flexShrink:0}}/>
        {/* Поиск */}
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Поиск..."
          style={{padding:'4px 10px',fontSize:11,borderRadius:6,border:'1px solid rgba(255,255,255,0.12)',
            background:'rgba(255,255,255,0.04)',color:'var(--text)',outline:'none',width:160}}/>
        <DateSelector
          from={from} to={to}
          onChange={handleDateChange}
          lastSync={data?.lastSync}
          onSync={handleSync}
          syncing={syncing}
          syncBlockSecs={syncBlockSecs}
          blurIds={blurIds}
          onToggleBlur={toggleBlur}
          onSyncFbs={handleSyncFbs}
          syncingFbs={syncingFbs}
          fbsSyncStatus={fbsSyncStatus}
          syncLimits={syncLimits}
          initialMode={saved?.dateMode || '30days'}
          initialFrom={initFrom}
          initialTo={initTo}
        />
      </div>
      {syncRunning&&<div style={{margin:'6px 12px',padding:'6px 12px',background:'rgba(59,130,246,0.1)',border:'1px solid rgba(59,130,246,0.2)',borderRadius:6,fontSize:12,color:'var(--accent)'}}>
        ⟳ Загрузка данных...
      </div>}
      {syncMsg==='done'&&<div style={{margin:'6px 12px',padding:'6px 12px',background:'rgba(16,185,129,0.1)',border:'1px solid rgba(16,185,129,0.3)',borderRadius:6,fontSize:12,color:'#10b981',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        ✅ Данные обновлены!
        <button onClick={()=>{ setSyncMsg(null); window.location.reload(true); }} style={{padding:'2px 10px',borderRadius:4,border:'1px solid rgba(16,185,129,0.4)',background:'rgba(16,185,129,0.15)',color:'#10b981',cursor:'pointer',fontSize:11}}>Сбросить кэш</button>
      </div>}
      {syncMsg&&syncMsg!=='done'&&<div style={{margin:'6px 12px',padding:'6px 12px',background:'rgba(59,130,246,0.1)',border:'1px solid rgba(59,130,246,0.2)',borderRadius:6,fontSize:12,color:'var(--accent)'}}>
        {syncMsg}
      </div>}
      {error&&<div style={{margin:'6px 12px',padding:'6px 12px',background:'rgba(239,68,68,0.1)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:6,color:'var(--red)',fontSize:12}}>Ошибка: {error}</div>}
      <div style={{flex:1,overflow:'hidden',display:'flex',position:'relative',zIndex:1}}>
        {loading&&(
          <div style={{position:'absolute',inset:0,zIndex:20,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'rgba(10,15,26,0.85)',backdropFilter:'blur(8px)'}}>
            <img src={catGif} alt="loading"
              style={{width:140,height:140,objectFit:'contain',borderRadius:16,marginBottom:16}}/>
            <div style={{fontSize:13,color:'rgba(148,163,184,0.6)',letterSpacing:'2px',textTransform:'uppercase'}}>загружаем данные...</div>
          </div>
        )}
        {data&&(
          <TableContainer
            dates={data.dates} articles={sortedArticles} widths={widths} adMarks={adMarks} toggleAdMark={toggleAdMark} lastAdDate={lastAdDate} search={search} onCommentChange={onCommentChange}
            startResize={startResize} buyoutWeeks={buyoutWeeks}
            sortConfig={sortConfig} onSort={handleSort}
            onSaved={handleSaved} loading={loading} lastSync={data.lastSync}
            savedScroll={saved?.scrollTop||0}
            onScroll={(top) => saveRef.current({...savedRef.current, scrollTop:top})}
            favorites={favorites} onToggleFavorite={async (nmId) => {
              const id = String(nmId);
              if (favorites.has(id)) {
                await api.delete(`/monitoring/favorites/${id}`);
                setFavorites(prev => { const s=new Set(prev); s.delete(id); return s; });
              } else {
                await api.post(`/monitoring/favorites/${id}`);
                setFavorites(prev => new Set([...prev, id]));
              }
            }}
                  hidden={hidden} toggleHidden={toggleHidden} showHidden={showHidden}
        tags={tags} tagFilter={tagFilter} handleTag={handleTag}
          />
        )}
      </div>
    </div>
  );
}
